import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';

const ProfilePage = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  const handleBack = () => {
    if (user?.user_type === 'vendeur') {
      navigate('/dashboard-vendeur');
    } else {
      navigate('/dashboard-acquereur');
    }
  };

  return (
    <div className="min-h-screen bg-background">
      <header className="sticky top-0 z-50 bg-white/80 backdrop-blur-xl backdrop-saturate-150 border-b border-white/40">
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center gap-4">
          <Button
            onClick={handleBack}
            variant="ghost"
            size="icon"
            className="rounded-full"
            data-testid="back-button"
          >
            <ArrowLeft className="w-5 h-5" />
          </Button>
          <h1 className="font-playfair text-2xl font-bold text-foreground">Mon Profil</h1>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-6 py-12">
        <div className="bg-white border border-border rounded-2xl p-8">
          <div className="flex items-center gap-6 mb-8">
            {user?.picture && (
              <img
                src={user.picture}
                alt={user.name}
                className="w-20 h-20 rounded-full"
              />
            )}
            <div>
              <h2 className="font-manrope text-2xl font-bold text-foreground mb-1">
                {user?.name}
              </h2>
              <p className="text-muted-foreground">{user?.email}</p>
            </div>
          </div>

          <div className="space-y-6">
            <div>
              <label className="block text-sm font-manrope font-semibold text-foreground mb-2">
                Type de compte
              </label>
              <p className="text-foreground capitalize">
                {user?.user_type}
              </p>
            </div>

            <div className="pt-6 border-t">
              <p className="text-sm text-muted-foreground">
                Pour modifier vos informations ou supprimer votre compte, contactez-nous à contact@omero.fr
              </p>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default ProfilePage;
